import { Option } from "../../shared/types/option";

import { OrdersFilterFormValues } from "./types";

export const ORDER_QUERY_KEY = "order";
export const ORDER_LIST_QUERY_KEY = "order-list";
export const ORDER_TYPES_QUERY_KEY = "order-types";
export const ORDER_PHOTO_QUERY_KEY = "order-photo";
export const ORDER_TEMPLATE_IMAGE_QUERY_KEY = "order-template-image";
export const ORDER_TEMPLATE_VIEWS_QUERY_KEY = "order-template-views";
export const ORDER_CREATE_SCHEMA_QUERY_KEY = "order-create-schema";
export const ORDERS_COUNT_PER_PAGE = 15;

export const ORDER_LIST_SORT_FIELDS = {
  createdAt: "CreatedAt",
  plannedCompletionDate: "PlannedCompletionDate",
  projectName: "ProjectName",
  unit: "Unit",
  typeName: "TypeName",
  status: "Status",
} as const;

export const ORDERS_FILTER_FORM_DEFAULT_VALUES: OrdersFilterFormValues = {
  statuses: [],
  rentAreas: [],
  orderTypes: [],
  slaFrom: "",
  slaTo: "",
  createdFrom: "",
  createdTo: "",
};

export const EMPTY_PERMISSIONS = {
  visible: [],
  canEdit: [],
  required: [],
};

export const ORDER_ORIGINS_FORM_VALUES: { [key: string]: string } = {
  IncomingCall: "Входящий звонок",
  FaceToFaceVisit: "Очный визит",
  SocialMedia: "Социальные сети",
  Messengers: "Мессенджеры",
  ManagingCompany: "Обращение от УК",
};

export const ORDER_ORIGINS: { [key: string]: string } = {
  ...ORDER_ORIGINS_FORM_VALUES,
  RentMobileApplication: "МП Арендатора",
  EmployeeMobileApplication: "МП Сотрудника",
};

export const ORDER_SMS_RETRY_TIMEOUT_SEC = 60;

export const ORDER_STATUS_OPTIONS: Option[] = [
  { value: "New", label: "Новая, На согласовании" },
  { value: "InProgress", label: "В работе" },
  { value: "Completed", label: "Завершено" },
  { value: "Approved", label: "Согласовано" },
  { value: "Declined", label: "Отклонено" },
  { value: "Canceled", label: "Отменено" },
];

export const TENANT_VISIBLE_ORDER_STATUSES = [
  "New",
  "InProgress",
  "Completed",
  "Approved",
  "Declined",
  "Canceled",
] as const;
